import {XauditModel} from '../xaudit.model';
import {EnumValidValueItemModel} from '../enum/enum-valid-value-item.model';

export class NoteTypeDataModel extends XauditModel {
  public NoteTypeId: string;
  public NoteId: string;
  public enumNoteTypeID: string;
  public enumNoteType: EnumValidValueItemModel;
}
